// extracted by mini-css-extract-plugin
export default {"tab-pane":"_tQiz","pricing-summary-footer":"S3iT_"};